import {gql} from "@apollo/client";
import {ORDER_FIELDS} from "../../../../central/parcels/graphql/queries/getOrderListingForCentral";

// 字段与 Central 包裹列表一致，仅换后端 resolver 以挂 CS_PACKAGE 资源码；
// 别名回 getOrderListingForCentral，使 useCentralParcelQuery 的取值路径无需改动
export const GET_CUSTOMER_SERVICE_PARCELS = gql`
    query CustomerServiceParcels($filters: OrderFiltersTypeInput,
                                 $pageRequest: PageRequestTypeInput) {
        getOrderListingForCentral: getOrderListingForCustomerServiceParcels(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${ORDER_FIELDS}
                recipientAddress {
                    id
                    fullName
                    countryCode
                    phoneNumber
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                    company
                    instructions
                }
            }
            page
            size
            totalElements
            totalPages
            accessiblePages
            hasNext
            hasPrevious
        }
    }
`;
